import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';

@Component({
    selector: 'app-wizard-language-style',
    templateUrl: './wizard-language-style.component.html',
    styleUrls: ['./wizard-language-style.component.scss']
})
export class WizardLanguageStyleComponent {

    @Input() easyLanguageStyleVisible: boolean | undefined;
    @Input() isAudioMode: boolean;
    @Output() nextStepEvent: EventEmitter<LanguageStyleEnum> = new EventEmitter();

    languageStyleEasy = LanguageStyleEnum.EASY;
    languageStyleSimple = LanguageStyleEnum.SIMPLE;
    languageStyleStandard = LanguageStyleEnum.STANDARD;

    nextStepClick(style: LanguageStyleEnum): void {
        this.nextStepEvent.emit(style);
    }
}
